export const subSemesters = (date: Date, number: number) => {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();

    // Calculate the current semester (0 for first, 1 for second)
    const currentSemester = month >= 6 ? 1 : 0;

    // Calculate the target semester after subtracting 'number' semesters
    const targetSemester = currentSemester - number;

    // Calculate the adjusted target semester (handle negative values)
    const adjustedTargetSemester = (targetSemester + 2) % 2;

    // Calculate the number of months into the target semester
    const monthsIntoSemester = month - (currentSemester === 1 ? 6 : 0);

    // Calculate the target month with the same relative position within the semester
    const targetMonth = (adjustedTargetSemester === 0 ? 0 : 6) + monthsIntoSemester;

    // Calculate the year for the target semester
    let targetYear = year;

    if (targetSemester < 0) {
        targetYear -= Math.floor((-targetSemester + 1) / 2);
    } else {
        targetYear -= Math.floor(targetSemester / 2);
    }

    // Calculate the last day of the target month
    const lastDayOfTargetMonth = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();

    // Adjust the target day if it exceeds the last day of the target month
    const targetDay = Math.min(day, lastDayOfTargetMonth);

    return new Date(Date.UTC(targetYear, targetMonth, targetDay));
};

export const startOfSemester = (date: Date) => {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();

    if (month <= 5) {
        return new Date(Date.UTC(year, 0, 1, 0, 0, 0, 0));
    }
    return new Date(Date.UTC(year, 6, 1, 0, 0, 0, 0));
};

export const endOfSemester = (date: Date) => {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();

    if (month <= 5) {
        return new Date(Date.UTC(year, 5, 30, 23, 59, 59, 999));
    }
    return new Date(Date.UTC(year, 11, 31, 23, 59, 59, 999));
};

export const getResolutionTranslation = (resolution: string) => {
    switch (resolution) {
        case 'B':
            return 'BASIC';
        case 'FM':
            return 'FIVE_MINUTE';
        case 'TM':
            return 'TEN_MINUTE';
        case 'QH':
            return 'QUARTER_HOUR';
        case 'HH':
            return 'HALF_HOUR';
        case 'H':
            return 'HOUR';
        case 'D':
            return 'DAY';
        case 'W':
            return 'WEEK';
        case 'M':
            return 'MONTH';
        case 'Y':
            return 'YEAR';
        default:
            throw Error('Invalid resolution');
    }
};

export const normalizeDateFormat = (inputFormat = 'dd/MM/yyyy'): string =>
    inputFormat.replace(/dd/i, 'DD').replace(/d/i, 'D').replace(/MM/, 'MM').replace(/M/, 'M').replace(/yyyy/i, 'YYYY').replace(/yy/i, 'YY');
